import React, { useEffect, useState, useRef } from "react";
import FilterComponent from "../../SelectChannelsAndPacks/FilterComponent/FilterComponent";
import HdIcon from "../../SelectChannelsAndPacks/hd-icon.svg";
import SdIcon from "../../SelectChannelsAndPacks/sd-icon.svg";
import RightIcon from "../../SelectChannelsAndPacks/right-icons.svg";
import FilterIcon from "../../SelectChannelsAndPacks/filter-icon.svg";
// import defaultBox from "../../../../images/img/default-box.png";
import defaultChannel from "../../SelectChannelsAndPacks/default-channel.png";
import apiService from "../../../Services/apiServices";
import PackDescriptionComponent from "../../SelectChannelsAndPacks/PackDesription/PackDescriptionComponent";
import ScrollerWithArrows from "../../AddRemovePacksChannels/Utils/ScrollerWithArrows";
import $ from "jquery";

import "./home.css";
import secureLocalStorage from "react-secure-storage";

export default function AddRemovePacksAndChannels(props) {
  //todo pack description component pending
  //todo onClick of view channel list component toggle PackDescription Componrnt with props
  //constants or variables
  const {
    filters,
    selectedLanguagesProps,
    allLanguagesProps,
    selectedGenresProps,
    allGenresProps,
    filterTag,
    filterToggle,
    onClickSubmit,
    tag,
    code,
    text_data,
    selectedHd,
    prioratizePacks,
    addChannelList,
    addPackList,
    dropChannelList,
    dropPackList,
    confirmCode,
    showMaximumChat,
  } = props;

  
  const channelRef = useRef(null);
  const packsRef = useRef(null);

  const dropChannelRef = useRef(null);
  const dropPacksRef = useRef(null);

  const confirmRef = useRef(null);
  const startingRef = useRef(null);
  //states
  const [applyFilterToggle, setApplyFilterToggle] = useState(false);
  const [channels, setChannels] = useState(addChannelList);
  const [packs, setPacks] = useState(addPackList);

  const [minimumChannelScrollValue, setMinimumChannelScrollValue] =
    useState("");

  const [minimumPacksScrollValue, setMinimumPackscrollValue] = useState("");

  const [minimumDropChannelScrollValue, setMinimumDropChannelScrollValue] =
    useState("");

  const [minimumDropPacksScrollValue, setMinimumDropPackscrollValue] =
    useState("");

  const [dropChannels, setDropChannels] = useState(dropChannelList);
  const [dropPacks, setDropPacks] = useState(dropPackList);

  const [count, setCount] = useState(0);
  const [refresh, setRefres] = useState(false);
  const [selectedGenres, setSelectedGenres] = useState(selectedGenresProps);
  const [selectedLanguages, setSelectedLanguages] = useState(
    selectedLanguagesProps
  );
  const [allGenres, setAllGenres] = useState(allGenresProps);
  const [allLanguages, setAllLanguages] = useState(allLanguagesProps);
  const [enableDescriptionComponent, setEnableDescriptionComponent] = useState({
    toggle: false,
    data: null,
  });
  const [selectedPacks, setSelectedPacks] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);

  const [disabled, setDisabled] = useState(true);

  const [lastIndexChannel, setLastIndexChannel] = useState(
    addChannelList?.length - 1
  );

  const [lastIndexPacks, setLastIndexPacks] = useState(addPackList?.length - 1);

  const [showChannelLeft, setShowChannelLeft] = useState(false);

  const [showChannelRight, setShowChannelRight] = useState(
    addChannelList?.length > 3 ? true : false
  );

  const [showPackLeft, setShowPackLeft] = useState(false);

  const [showPackRight, setShowPackRight] = useState(
    addPackList?.length > 1 ? true : false
  );

  const [dropLastIndexChannel, setDropLastIndexChannel] = useState(
    dropChannelList?.length - 1
  );

  const [dropLastIndexPacks, setDropLastIndexPacks] = useState(
    dropPackList?.length - 1
  );

  const [showDropChannelLeft, setShowDropChannelLeft] = useState(false);

  const [showDropChannelRight, setShowDropChannelRight] = useState(
    dropChannelList?.length > 3 ? true : false
  );

  const [showDropPackLeft, setShowDropPackLeft] = useState(false);

  const [showDropPackRight, setShowDropPackRight] = useState(
    dropPackList?.length > 1 ? true : false
  );

  //useEffects
  useEffect(() => {
    channels.map((chan) => (chan.checked = false));
    startingRef?.current?.scrollIntoView();
  }, []);

  const scrollOnAction = () => {
    confirmRef.current.scrollIntoView();
  };

  const specialCode = secureLocalStorage.getItem("specialCode");

  useEffect(() => {
    packs.map((pa) => (pa.checked = false));
  }, []);

  useEffect(() => {
    let selectedChannels =
      (channels &&
        channels?.filter((oneChannel) => oneChannel.checked === true)) ||
      [];

    let selectedpacks =
      (packs && packs?.filter((onePack) => onePack.checked === true)) || [];

    let dropChannelsLength =
      (dropChannels &&
        dropChannels?.filter((oneChannel) => oneChannel.checked === true)) ||
      [];

    let dropPacksLength =
      (dropPacks && dropPacks?.filter((onePack) => onePack.checked === true)) ||
      [];

    if (
      selectedChannels?.length > 0 ||
      selectedpacks?.length > 0 ||
      dropChannelsLength?.length > 0 ||
      dropPacksLength?.length > 0
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [channels, packs, dropChannels, dropPacks]);

  //functions
  const handleApplyFilters = () => {
    setApplyFilterToggle(!applyFilterToggle);
  };

  const onClickChannelHandler = (channel) => {
    // scrollOnAction();
    var temp = [];
    if (channel.checked === false) {
      channel.checked = true;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    } else {
      channel.checked = false;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    }

    setChannels(temp);
  };

  useEffect(() => {
    //map through all channels and set a checked filed as false
    //map through all packs and set a checked filed as false
    dropChannels && dropChannels.map((chan) => (chan.checked = false));
    startingRef?.current?.scrollIntoView();
  }, []);

  useEffect(() => {
    dropPacks && dropPacks.map((pa) => (pa.checked = false));
  }, []);

  const onClickDropChannelHandler = (channel) => {
    // scrollOnAction();
    var temp = [];
    if (channel.checked === false) {
      channel.checked = true;
      temp = dropChannels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    } else {
      channel.checked = false;
      temp = dropChannels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    }

    setDropChannels(temp);
    setRefres(!refresh);
  };

  const isSupportedImage = (imageLink) => {
    console.log(imageLink, "image link");
    if (imageLink.toString().includes(".gif")) {
      return imageLink;
    } else {
      return imageLink;
    }
  };

  const onPackClickHandler = (pack) => {
    // scrollOnAction();
    var temp = [];
    if (pack.checked === false) {
      pack.checked = true;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    } else {
      pack.checked = false;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    }

    setPacks(temp);
  };

  const onDropPackClickHandler = (pack) => {
    // scrollOnAction();
    var temp = [];
    if (pack.checked === false) {
      pack.checked = true;
      temp = dropPacks.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    } else {
      pack.checked = false;
      temp = dropPacks.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    }

    setDropPacks(temp);
    setRefres(!refresh);
  };

  const onConfirmHandler = () => {
    console.log("onConfirmHandler1", confirmCode, tag);

    let tempselectedChannels = channels
      .filter((oneChannel) => oneChannel.checked === true)
      .map((oneChannel) => oneChannel);

    let tempselectedPacks = packs
      .filter((onePAck) => onePAck.checked === true)
      .map((onePack) => onePack);

    let tempDropselectedChannels = dropChannels
      .filter((oneChannel) => oneChannel.checked === true)
      .map((oneChannel) => oneChannel);

    let tempDropselectedPacks = dropPacks
      .filter((onePAck) => onePAck.checked === true)
      .map((onePack) => onePack);

    setSelectedChannels(tempselectedChannels);
    setSelectedPacks(tempselectedPacks);

    // if (
    //   tempselectedPacks.length === 0 ||
    //   tempselectedChannels.length === 0 ||
    //   tempDropselectedChannels.length === 0 ||
    //   tempsDropelectedChannels === 0
    // ) {
    //   return;
    // }

    onClickSubmit(
      confirmCode,
      JSON.stringify( {
        addChannelName: channels
          .filter((oneChannel) => oneChannel?.checked === true)
          .map((oneChannel) => oneChannel?.name),
        addPackName: packs
          .filter((onePAck) => onePAck?.checked === true)
          .map((onePack) => onePack?.name),

        dropChannelName: dropChannels
          .filter((oneChannel) => oneChannel.checked === true)
          .map((oneChannel) => oneChannel?.name),
        dropPackName: dropPacks
          .filter((onePAck) => onePAck?.checked === true)
          .map((onePack) => onePack?.name),
      }),
      tag
    );

    filterToggle(true);

    localStorage.setItem(
      "modPacks",
      JSON.stringify({
        addChannelNames: tempselectedChannels,
        addPackNames: tempselectedPacks,
        dropChannelNames: tempDropselectedChannels,
        dropPackNames: tempDropselectedPacks,
      })
    );
  };

  const updateCount = (data) => {
    setCount(data);
    setRefres(!refresh);
  };

  const onClickFilterHandler = (code, data, tag) => {
    setApplyFilterToggle(false);

    apiService.inputPostResonse(code, data).then((response) => {
      console.log("jhgvjbvjsk", response);
      const targetEntry = response?.data?.chatResponse?.entries.find(
        (entry) => entry?.uiCommand === "A63"
      );
      var tempChannels = [];
      var tempPacks = [];
      var tempDropChannels = [];
      var tempDropPacks = [];

      tempChannels =
        targetEntry?.text_data?.add?.channels
          ?.channelList;

      tempChannels !== undefined &&
        tempChannels.map((chan) => (chan.checked = false));

      tempPacks =
        targetEntry?.text_data?.add
          ?.packsWithChannel?.packList;

      tempPacks !== undefined && tempPacks.map((pa) => (pa.checked = false));

      tempDropChannels =
        targetEntry?.text_data?.drop?.channels
          ?.channelList;

      tempDropChannels !== undefined &&
        tempDropChannels.map((chan) => (chan.checked = false));

      tempDropPacks =
        targetEntry?.text_data?.add
          ?.packsWithChannel?.packList;

      tempDropPacks !== undefined &&
        tempDropPacks.map((pa) => (pa.checked = false));

      
      setChannels(tempChannels);
      setPacks(tempPacks);
      setDropChannels(tempDropChannels);
      setDropPacks(tempDropPacks);
      setAllLanguages(
        targetEntry?.text_data?.filter?.language
          ?.listOfLanguages
      );
      setSelectedLanguages(
        targetEntry?.text_data?.filter?.language
          ?.selectedLanguages
      );
      setAllGenres(
        targetEntry?.text_data?.filter?.genre
          ?.listOfGenre
      );
      setSelectedGenres(
        targetEntry?.text_data?.filter?.genre
          ?.selectedGenre
      );
      setRefres(!refresh);
      setRefres(!refresh);
    });
  };

  const enableDescription = (e, data) => {
    e?.stopPropagation?.();
    localStorage.setItem("packDescription", JSON.stringify(data));
    setEnableDescriptionComponent({
      toggle: true,
      data: data,
    });
  };

  const selectDescription = (data) => {
    onPackClickHandler(enableDescriptionComponent.data);
    setEnableDescriptionComponent({
      toggle: false,
      data: null,
    });
  };

  useEffect(() => {
    if (channels !== undefined && channels !== null && channels.length !== 0) {
      let element = document.getElementById("addChannelsRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = element;
        setMinimumChannelScrollValue(position.offsetLeft);
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [channels]);

  useEffect(() => {
    if (packs !== undefined && packs !== null && packs.length !== 0) {
      let element = document.getElementById("addPacksRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = element;
        setMinimumPackscrollValue(position.offsetLeft);
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [packs]);

  useEffect(() => {
    if (
      dropChannels !== undefined &&
      dropChannels !== null &&
      dropChannels.length !== 0
    ) {
      let element = document.getElementById("dropChannelsRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = element;
        setMinimumDropChannelScrollValue(position.offsetLeft);
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [dropChannels]);

  useEffect(() => {
    if (
      dropPacks !== undefined &&
      dropPacks !== null &&
      dropPacks.length !== 0
    ) {
      let element = document.getElementById("dropPacksRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = element;
        setMinimumDropPackscrollValue(position.offsetLeft);
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [dropPacks]);

  useEffect(() => {
    if (channels !== undefined && channels !== null && channels.length !== 0) {
      let element = document.getElementById("addChannelsRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = $("#addchannelId-0").offset();

        let lastPositoin = $(`#addchannelId-${lastIndexChannel}`).offset();

        let isShowLastone = Math.abs(
          $(".addChannelsSliderContainer").width() - lastPositoin?.left
        );

        if (position.left < 0) {
          setShowChannelLeft(true);
        } else {
          setShowChannelLeft(false);
        }

        if (isShowLastone > 100 && isShowLastone < 105) {
          setShowChannelRight(false);
        } else if (channels.length < 3) {
          setShowChannelRight(false);
        } else {
          setShowChannelRight(true);
        }
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [channels, lastIndexChannel]);

  useEffect(() => {
    if (packs !== undefined && packs !== null && packs.length !== 0) {
      let element = document.getElementById("addPacksRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = $("#packId-0").offset();

        let lastPositoin = $(`#packId-${lastIndexPacks}`).offset();

        let isShowLastone = Math.abs(
          $(".addPacksSilderContainer").width() - lastPositoin?.left
        );

        if (position.left < 0) {
          setShowPackLeft(true);
        } else {
          setShowPackLeft(false);
        }

        if (isShowLastone > 240 && isShowLastone < 245) {
          setShowPackRight(false);
        } else if (packs.length < 2) {
          setShowPackRight(false);
        } else {
          setShowPackRight(true);
        }
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [packs, lastIndexPacks]);

  useEffect(() => {
    if (
      dropChannels !== undefined &&
      dropChannels !== null &&
      dropChannels.length !== 0
    ) {
      let element = document.getElementById("dropChannelsRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = $("#dropChannelId-0").offset();

        let lastPositoin = $(`#dropChannelId-${dropLastIndexChannel}`).offset();

        let isShowLastone = Math.abs(
          $(".dropChannelsSliderContainer").width() - lastPositoin?.left
        );

        if (position.left < 0) {
          setShowDropChannelRight(true);
        } else {
          setShowDropChannelRight(false);
        }

        if (isShowLastone > 100 && isShowLastone < 105) {
          setShowDropChannelRight(false);
        } else {
          setShowDropChannelRight(true);
        }
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [dropChannels, dropLastIndexChannel]);

  useEffect(() => {
    if (
      dropPacks !== undefined &&
      dropPacks !== null &&
      dropPacks.length !== 0
    ) {
      let element = document.getElementById("dropPacksRef");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = $("#dropPackId-0").offset();

        let lastPositoin = $(`#dropPackId-${dropLastIndexPacks}`).offset();

        let isShowLastone = Math.abs(
          $(".dropPacksSilderContainer").width() - lastPositoin?.left
        );

        if (position.left < 0) {
          setShowDropPackLeft(true);
        } else {
          setShowDropPackLeft(false);
        }

        if (isShowLastone > 240 && isShowLastone < 245) {
          setShowDropPackRight(false);
        } else if (dropPacks.length < 2) {
          setShowDropPackRight(false);
        } else {
          setShowDropPackRight(true);
        }
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [dropPacks, dropLastIndexPacks]);

  //useEffects
  return (
    <div>
      {enableDescriptionComponent.toggle && (
        <PackDescriptionComponent
          data={enableDescriptionComponent.data}
          closeDescriptionComponent={() => setEnableDescriptionComponent(false)}
          selectDesctipon={() => selectDescription()}
          showMaximumChat={showMaximumChat}
        />
      )}
      {/* <div className="applyFilterContainer" ref={startingRef}>
        {applyFilterToggle && count > 0 && (
          <div key={count} id="filterCount">
            {count}
          </div>
        )}
        <div className="buttonContainer btn-animate chat-label action-tab">
          <img src={FilterIcon} alt="filter"></img>
          <span onClick={() => handleApplyFilters()}>Apply Filters</span>
        </div>
      </div> */}
      {/* <div className="filterContainer-packList">
        {applyFilterToggle ? (
          <FilterComponent
            filters={props?.filters}
            selectedLanguagesProps={selectedLanguages}
            allLanguagesProps={allLanguages}
            selectedGenresProps={selectedGenres}
            allGenresProps={allGenres}
            onClickFilter={onClickFilterHandler}
            filterTag={filterTag}
            filterToggle={filterToggle}
            setCount={updateCount}
            code={localStorage.getItem("filterCode")}
            selectedHd={selectedHd}
          />
        ) : null}
      </div> */}
      <div
        style={{
          display: "flex",
          width: "99%",
          flexDirection: "column",
          paddingLeft: "1%",
        }}
      >
        {
          <div className="channelsListContainer">
            {(
              channels !== undefined &&
              channels !== null &&
              channels.length !== 0
            ) && (
              <div className="channelsHeaderContainer">
              <p>Add Channels</p>
              <span></span>
            </div>
            )}
            {channels !== undefined &&
              channels !== null &&
              channels.length !== 0 && (
                <ScrollerWithArrows
                  dontShow={channels?.length === 0}
                  width="100%"
                  height="12rem"
                  findMinimumScrollValue={minimumChannelScrollValue}
                  isShowLeft={showChannelLeft}
                  isShowRight={showChannelRight}
                  setShowLeft={setShowChannelLeft}
                  setShowRight={setShowChannelRight}
                  lastIndex={lastIndexChannel}
                  parentId="addChannelsRef"
                  childId="addchannelId"
                  minimumValue={100}
                  maximumValue={105}
                  showMaximumChat={showMaximumChat}
                >
                  <div
                    className="addChannelsSliderContainer"
                    id="addChannelsRef"
                    ref={channelRef}
                    width="100%"
                  >
                    {channels !== undefined &&
                    channels !== null &&
                    channels.length !== 0 ? (
                      channels.map((oneChannel, index) => (
                        <div
                          key={index}
                          id={`addchannelId-${index}`}
                          className="oneChannelBox action-tab"
                          onClick={() => onClickChannelHandler(oneChannel)}
                          style={{
                            border: oneChannel.checked
                              ? "1px solid #F07FC8"
                              : "none",
                            width: "30%",
                          }}
                        >
                          <div className="oneChannel-checkbox">
                            <input
                              type="checkbox"
                              value={oneChannel.name}
                              checked={oneChannel.checked}
                            ></input>
                          </div>
                          <div className="oneChannel-nameLogo">
                            <img
                              src={oneChannel.imageLink}
                              onError={(e) => (e.target.src = defaultChannel)}
                              alt="error"
                            ></img>
                            <p style={{display : 'flex' , justifyContent : 'center'}}>{oneChannel.name} <div style={{marginLeft : '4px'}}>({oneChannel.channelNo})</div></p>
                          </div>
                          <div className="oneChannel-priceContainer">
                            <p>{oneChannel.description}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No Channels</p>
                    )}
                  </div>
                </ScrollerWithArrows>
              )}
          </div>
        }
        {
          <div className="packsListContainer">
            {(packs !== undefined && packs !== null && packs.length !== 0) &&(
               <div className="packsList-header">
               <p>Add Packs with the channel</p>
               <span></span>
             </div>
            ) }
            {packs !== undefined && packs !== null && packs.length !== 0 && (
              <ScrollerWithArrows
                dontShow={packs?.length === 0}
                width="100%"
                height="14rem"
                findMinimumScrollValue={minimumPacksScrollValue}
                isShowLeft={showPackLeft}
                isShowRight={showPackRight}
                setShowLeft={setShowPackLeft}
                setShowRight={setShowPackRight}
                lastIndex={lastIndexPacks}
                parentId="addPacksRef"
                childId="packId"
                minimumValue={240}
                maximumValue={245}
                showMaximumChat={showMaximumChat}
              >
                <div
                  className="addPacksSilderContainer"
                  id="addPacksRef"
                  ref={packsRef}
                >
                  {packs.length !== 0 ? (
                    packs.map((onePack, index) => (
                      <div
                        id={`packId-${index}`}
                        key={index}
                        className="onePackBox action-tab"
                        onClick={() => onPackClickHandler(onePack)}
                        style={{
                          border: onePack.checked
                            ? "1px solid #F07FC8"
                            : "none",
                            width : showMaximumChat ? '20%' : '44%'
                        }}
                      >
                        <div className="onePackBox-checkbox">
                          <input
                            type="checkbox"
                            value={onePack}
                            checked={onePack.checked}
                          ></input>
                          <p style={{fontSize : showMaximumChat ? '12px' : '10px'}}>{onePack.name}</p>
                        </div>
                        <div className="onePackBox-price">
                          <div style={{fontSize : showMaximumChat ? '12px' : '10px'}}>{onePack.description}</div>{" "}
                        </div>
                        <div className="onePackBox-hdsd">
                          <div className="hdSdContainer">
                            <img src={HdIcon} alt="HdIcon"></img>
                            <p>{onePack.noOfHdChannels}</p>
                          </div>
                          <div className="hdSdContainer">
                            <img src={SdIcon} alt="SdIcon"></img>
                            <p>{onePack.noOfSdChannels}</p>
                          </div>
                        </div>
                        <div
                          className="onePackBox-link action-tab"
                          onClick={(e) => enableDescription(e, onePack)}
                        >
                          <p style={{fontSize : showMaximumChat ? '12px' : '10px'}}>View Channel List</p>
                          <img style={{width :'11px' , marginBottom : '4px'}}  src={RightIcon} alt="channel"></img>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Packs</p>
                  )}
                </div>
              </ScrollerWithArrows>
            )}
          </div>
        }
        {
          <div className="channelsListContainer">
            {(
              dropChannels !== undefined &&
              dropChannels !== null &&
              dropChannels.length !== 0
            ) && (
              <div className="channelsHeaderContainer">
              <p>Drop Channels</p>
              <span></span>
            </div>
            ) }
            {dropChannels !== undefined &&
              dropChannels !== null &&
              dropChannels.length !== 0 && (
                <ScrollerWithArrows
                  dontShow={dropChannels?.length === 0}
                  width="100%"
                  height="12rem"
                  findMinimumScrollValue={minimumDropChannelScrollValue}
                  isShowLeft={showDropChannelLeft}
                  isShowRight={showDropChannelRight}
                  setShowLeft={setShowDropChannelLeft}
                  setShowRight={setShowDropChannelRight}
                  lastIndex={dropLastIndexChannel}
                  parentId="dropChannelsRef"
                  childId="dropChannelId"
                  minimumValue={100}
                  maximumValue={105}
                  showMaximumChat={showMaximumChat}
                >
                  <div
                    className="dropChannelsSliderContainer"
                    id="dropChannelsRef"
                    ref={dropChannelRef}
                    width="100%"
                  >
                    {dropChannels !== undefined &&
                    dropChannels !== null &&
                    dropChannels.length !== 0 ? (
                      dropChannels.map((oneChannel, index) => (
                        <div
                          key={index}
                          id={`dropChannelId-${index}`}
                          className="oneChannelBox action-tab"
                          onClick={() => onClickDropChannelHandler(oneChannel)}
                          style={{
                            border: oneChannel.checked
                              ? "1px solid #F07FC8"
                              : "none",
                            width: "30%",
                          }}
                        >
                          <div className="oneChannel-checkbox">
                            <input
                              type="checkbox"
                              value={oneChannel.name}
                              checked={oneChannel.checked}
                            ></input>
                          </div>
                          <div className="oneChannel-nameLogo">
                            <img
                              src={oneChannel.imageLink}
                              onError={(e) => (e.target.src = defaultChannel)}
                              alt="error"
                            ></img>
                            <p style={{display : 'flex' , justifyContent : 'center'}}>{oneChannel.name} <div style={{marginLeft : '4px'}}>({oneChannel.channelNo})</div></p>
                          </div>
                          <div className="oneChannel-priceContainer">
                            <p>{oneChannel.description}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No Channels</p>
                    )}
                  </div>
                </ScrollerWithArrows>
              )}
          </div>
        }
        {
          <div className="packsListContainer">
            {(
              dropPacks !== undefined &&
              dropPacks !== null &&
              dropPacks.length !== 0
            ) && (
              <div className="packsList-header">
                <p>Drop Packs with the channel</p>
                <span></span>
              </div>
            )}
            {dropPacks !== undefined &&
              dropPacks !== null &&
              dropPacks.length !== 0 && (
                <ScrollerWithArrows
                  dontShow={dropPacks?.length === 0}
                  width="100%"
                  height="14rem"
                  findMinimumScrollValue={minimumDropPacksScrollValue}
                  isShowLeft={showDropPackLeft}
                  isShowRight={showDropPackRight}
                  setShowLeft={setShowDropPackLeft}
                  setShowRight={setShowDropPackRight}
                  lastIndex={dropLastIndexPacks}
                  parentId="dropPacksRef"
                  childId="dropPackId"
                  minimumValue={240}
                  maximumValue={245}
                  showMaximumChat={showMaximumChat}
                >
                  <div
                    className="dropPacksSilderContainer"
                    id="dropPacksRef"
                    ref={dropPacksRef}
                  >
                    {dropPacks.length !== 0 ? (
                      dropPacks.map((onePack, index) => (
                        <div
                          key={index}
                          id={`dropPackId-${index}`}
                          className="onePackBox"
                          onClick={() => onDropPackClickHandler(onePack)}
                          style={{
                            border: onePack.checked
                              ? "1px solid #F07FC8"
                              : "none",
                            width: "60%",
                          }}
                        >
                          <div className="onePackBox-checkbox">
                            <input
                              type="checkbox"
                              value={onePack}
                              checked={onePack.checked}
                            ></input>
                            <p style={{fontSize : showMaximumChat ? '12px' : '10px'}}>{onePack.name}</p>
                          </div>
                          <div className="onePackBox-price">
                            <div style={{fontSize : showMaximumChat ? '12px' : '10px'}}>{onePack.description}</div>{" "}
                          </div>
                          <div className="onePackBox-hdsd">
                            <div className="hdSdContainer">
                              <img src={HdIcon} alt="HdIcon"></img>
                              <p>{onePack.noOfHdChannels}</p>
                            </div>
                            <div className="hdSdContainer">
                              <img src={SdIcon} alt="SdIcon"></img>
                              <p>{onePack.noOfSdChannels}</p>
                            </div>
                          </div>
                          <div
                            className="onePackBox-link action-tab"
                            onClick={(e) => enableDescription(e, onePack)}
                          >
                            <p style={{fontSize : showMaximumChat ? '12px' : '10px'}}>View Channel List</p>
                            <img style={{width :'11px' , marginBottom : '4px'}}  src={RightIcon} alt="right"></img>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No Packs</p>
                    )}
                  </div>
                </ScrollerWithArrows>
              )}
          </div>
        }
      </div>
      <div className="confirmButtonContainer-channelsAndPacks action-button" ref={confirmRef}>
        <a
          disabled={disabled}
          className="action-tab top-level-menu btn btn-primary btn-lg waves-effect waves-light confirm-btn "
          style={{
            borderRadius: "6px",
            textAlign: "center",
            fontSize: "12px",
            background: disabled ? "red" : "grey",
            // marginRight:"7%",
          }}
          onClick={() => onConfirmHandler()}
          //   href="confirm"
        >
          <p style={{position :'relative', top : '6px'}}>Confirm</p>
        </a>
      </div>
    </div>
  );
}
